import React, { useState, useEffect, memo } from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  InputBase,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
} from "@material-ui/core"
import bibleBookList from "../../data/BookChapterList.json"
import { getMetadata } from "../../scripts/getMetadata"
import { getTranslation } from "../../scripts/getTranslation"
import { useStore } from "../../teafuljs/store"

const useStyles = makeStyles(theme => ({
  formControl: {
    marginLeft: 0,
    marginTop: 10,
    marginBottom: 10,
    width: 265,
  },
  select: {
    color: "black",
    WebkitAppearance: "none",
    textIndent: "1px",
    textAlign: "center",
    verticalAlign: "middle",
    textOverflow: "",
    "&:before": {
      WebkitAppearance: "none",
    },
    "&:after": {
      WebkitAppearance: "none",
    },
    marginTop: 10,
    borderBottom: "1px black solid",
    paddingLeft: 5,
  },
  icon: {
    fill: "black",
  },
  flag: {
    marginRight: 5,
  },
  menuItem: {
    position: "relative",
    display: "flex",
  },
  root: {
    flexGrow: 1,
    height: "auto",
  },
}))

const VersionSelect = memo(
  ({
    location,
  }) => {
    const classes = useStyles()
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0]
  const [version, setVersion] = useStore.version()
  const [history, setHistory] = useStore.history()
  const [searchID, setSearchID] = useStore.searchID()
    const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
    const [interlinear, setInterlinear] = useStore.interlinear()
    const [currentBook, setCurrentBook] = useStore.currentBook()
    const [metadata, setMetadata] = useStore.metadata()
    const [versionDisplay, updateVersionDisplay] = useState(version)

    useEffect(() => {
      if (version !== versionDisplay) {
        updateVersionDisplay(version)
      }
    }, [version])

    const getLangOptions = () => {
      let LanguageOptions = []
      const languageKeys = Object.keys(AvailableContent.content)
      languageKeys.forEach(key => {
        const langObj = {
          label: AvailableContent.content[key].language_name,
          value: key,
          language_code: AvailableContent.content[key].language_code,
        }
        LanguageOptions.push(langObj)
      })
      return LanguageOptions.sort(function(a, b) {
        var textA = a.label.toUpperCase()
        var textB = b.label.toUpperCase()
        return textA < textB ? -1 : textA > textB ? 1 : 0
      })
    }

    const getVersionOptions = langKey => {
      let VersionOptions = []
      const versionKeys = Object.keys(AvailableContent.content[langKey].versions)
      versionKeys.forEach(key => {
        const versionObj = {
          label: AvailableContent.content[langKey].versions[key],
          value: key,
        }
        VersionOptions.push(versionObj)
      })
      return VersionOptions.sort(function(a, b) {
        var textA = a.label.name.toUpperCase()
        var textB = b.label.name.toUpperCase()
        return textA < textB ? -1 : textA > textB ? 1 : 0
      })
    }

    function findFirstAvailableBook(language, version) {
      const booksInOrder = Object.keys(bibleBookList)
      let firstBook = ""
      booksInOrder.forEach(book => {
        if (
          AvailableContent.content[language][version][book] !== undefined &&
          firstBook === ""
        ) {
          firstBook = book
        }
      })
      return firstBook
    }

    const updateVersion = version => {
      setHistory([
        {
          page: location.pathname,
          language: language,
          version: version,
          segment: currentSegmentID,
          scrollY: window.scrollY,
        },
        ...history,
      ])
      setVersion(version)
      storeMetadata(language, version)
      if (interlinear) {
        setInterlinear(false)
      }
      if (location.pathname !== "/") {
        if (
          !AvailableContent.content[language][version][currentBook] ||
          !AvailableContent.content[language][version][currentBook].segments ||
          AvailableContent.content[language][version][currentBook].segments.indexOf(
            currentSegmentID
          ) === -1
        ) {
          const firstBookOfNewLanguage = Object.keys(
            AvailableContent.content[language][version]
          )[0]
          const firstSegmentOfNewLanguage =
            AvailableContent.content[language][version][firstBookOfNewLanguage].segments[1]
          setCurrentSegmentID(firstSegmentOfNewLanguage)
          setCurrentBook(firstBookOfNewLanguage)
          return
        }
      }
    }

    const storeMetadata = async (language, version) => {
      const retrievedMetadata = await getMetadata(language, version)
      setMetadata(retrievedMetadata)
    }

    function handleChange(event) {
      const selectedVersion = event.target.value
      setHistory([
        {
          page: location.pathname,
          language: language,
          version: version,
          segment: currentSegmentID,
          scrollY: window.scrollY,
        },
        ...history,
      ])
      setVersion(selectedVersion)
      storeMetadata(language, version)
      if (interlinear) {
        setInterlinear(false)
      }
      if (location.pathname !== "/") {
        if (
          !AvailableContent.content[language][selectedVersion][currentBook] ||
          !AvailableContent.content[language][selectedVersion][currentBook].segments ||
          AvailableContent.content[language][selectedVersion][currentBook].segments.indexOf(
            currentSegmentID
          ) === -1
        ) {
          const firstBookOfNewLanguage = Object.keys(
            AvailableContent.content[language][selectedVersion]
          )[0]
          const firstSegmentOfNewLanguage =
            AvailableContent.content[language][selectedVersion][firstBookOfNewLanguage]
              .segments[1]
          setCurrentSegmentID(firstSegmentOfNewLanguage)
          setCurrentBook(firstBookOfNewLanguage)
          return
        }
      }
    }

    return (
      <div>
        {!AvailableContent.content ? null : (
          <form className={classes.root} autoComplete="off">
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel
                shrink
                id="demo-simple-select-placeholder-label-label-version"
              >
                {getTranslation(translations, language, "UI", "menu_version")}
              </InputLabel>
              <Select
                labelId="demo-simple-select-placeholder-label-label-version"
                id="demo-simple-select-placeholder-label-version"
                value={versionDisplay}
                onChange={handleChange}
                className={classes.select}
                inputProps={{
                  classes: {
                    icon: classes.icon,
                  },
                }}
                input={<InputBase className={classes.input} />}
              >
                {getVersionOptions(language).map((version, index) => {
                  return (
                    <MenuItem key={index} value={version.value}>
                      <span>{version.label.name}</span>
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </form>
        )}
      </div>
    )
  }
)

export default VersionSelect
